<div class="loading-shade" *ngIf="isLoadingResults">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>

<ng-container *ngIf="!isLoadingResults">
  <ng-container *ngIf="criterion$ | async as criterion">
    <p *ngIf="isMain">
      {{
        criterion
          | propertyLocalized
            : ["criterionArabicDescription", "criterionEnglishDescription"]
          | async
      }}
    </p>

    <ng-container
      *ngIf="category.allSubsEvaluated; else checkIfallSubsEvaluated"
    >
      <div
        class="form-custom-warning"
        *ngIf="isSessionNotStarted || !criterion.allQuestionsAnswered"
      >
        <span
          *ngIf="
            isSessionNotStarted && !criterion.allQuestionsAnswered;
            else oneOfThem
          "
        >
          {{
            "forms.common.Criteria.Errors.QuestionsAnsweredAndSessionStarted"
              | translate
          }}
        </span>
        <ng-template #oneOfThem>
          <span *ngIf="isSessionNotStarted">
            {{ "forms.common.Criteria.Errors.SessionStarted" | translate }}
          </span>
          <span *ngIf="!criterion.allQuestionsAnswered">
            {{ "forms.common.Criteria.Errors.QuestionsAnswered" | translate }}
          </span>
        </ng-template>
      </div>
    </ng-container>
    <ng-template #checkIfallSubsEvaluated>
      <div class="form-custom-warning">
        <span>
          {{ "forms.common.Criteria.Errors.AllSubsEvaluated" | translate }}
        </span>
      </div>
    </ng-template>
  </ng-container>

  <form [formGroup]="form">
    <div *ngIf="isMain" [allowedSummaryType]="['All']">
      <app-copy-decision
        (clicked)="copy('complianceEvaluation')"
        [enabledCopy]="enabledCopy"
      >
        <mat-label class="font-weight-bold field-required"
          >{{ "forms.common.Criteria.categoriesCompliance" | translate }}
        </mat-label>
      </app-copy-decision>
      <mat-radio-group
        formControlName="complianceEvaluation"
        class="complianceContainer"
      >
        <mat-radio-button
          [value]="item.value"
          *ngFor="let item of decisionInput.categoriesCompliance"
        >
          {{ "forms.common.Criteria." + item.key | translate }}

          <mat-icon
            class="info"
            *ngIf="item.description"
            [matTooltip]="
              'forms.common.Criteria.' + item.description | translate
            "
          >
            info
          </mat-icon>
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="mb-2" *ngIf="isMain && category" [allowedSummaryType]="['All']">
      <app-masar-total-statistic-preview
        [category]="category"
      ></app-masar-total-statistic-preview>
    </div>

    <div [allowedSummaryType]="['All', 'AllSummary', 'OnlyCriterionSummary']">
      <app-copy-decision
        (clicked)="copy('criterionSummary')"
        [enabledCopy]="enabledCopy || enabledCopyToExecutiveSummary"
        [prefix]="
          enabledCopyToExecutiveSummary
            ? 'forms.common.Criteria.ToExecutiveSummary'
            : ''
        "
      >
        <mat-label class="font-weight-bold field-required"
          >{{ "forms.common.Criteria.CriterionSummary" | translate }}
        </mat-label>
      </app-copy-decision>
      <mat-form-field appearance="outline">
        <textarea
          matInput
          cdkAutosizeMinRows="3"
          cdkAutosizeMaxRows="3"
          formControlName="criterionSummary"
        ></textarea>
      </mat-form-field>
    </div>

    <div [allowedSummaryType]="['All', 'AllSummary']">
      <app-copy-decision
        (clicked)="copy('summaryOfRecommendations')"
        [enabledCopy]="enabledCopy || enabledCopyToExecutiveSummary"
        [prefix]="
          enabledCopyToExecutiveSummary
            ? 'forms.common.Criteria.ToExecutiveSummary'
            : ''
        "
      >
        <mat-label class="font-weight-bold field-required">
          {{ "forms.common.Criteria.summaryOfRecommendations" | translate }}
        </mat-label>
      </app-copy-decision>
      <mat-form-field appearance="outline">
        <textarea
          matInput
          cdkAutosizeMinRows="3"
          cdkAutosizeMaxRows="3"
          formControlName="summaryOfRecommendations"
        ></textarea>
      </mat-form-field>
    </div>

    <div [allowedSummaryType]="['All', 'AllSummary']">
      <app-copy-decision
        (clicked)="copy('summaryOfCommendations')"
        [enabledCopy]="enabledCopy || enabledCopyToExecutiveSummary"
        [prefix]="
          enabledCopyToExecutiveSummary
            ? 'forms.common.Criteria.ToExecutiveSummary'
            : ''
        "
      >
        <mat-label class="font-weight-bold field-required">
          {{ "forms.common.Criteria.summaryOfCommendations" | translate }}
        </mat-label>
      </app-copy-decision>
      <mat-form-field appearance="outline">
        <textarea
          matInput
          cdkAutosizeMinRows="3"
          cdkAutosizeMaxRows="3"
          formControlName="summaryOfCommendations"
        ></textarea>
      </mat-form-field>
    </div>

    <div [allowedSummaryType]="['All', 'AllSummary']">
      <app-copy-decision
        (clicked)="copy('summaryOfSuggestions')"
        [enabledCopy]="enabledCopy || enabledCopyToExecutiveSummary"
        [prefix]="
          enabledCopyToExecutiveSummary
            ? 'forms.common.Criteria.ToExecutiveSummary'
            : ''
        "
      >
        <mat-label class="font-weight-bold field-required">
          {{ "forms.common.Criteria.summaryOfSuggestions" | translate }}
        </mat-label>
      </app-copy-decision>
      <mat-form-field appearance="outline">
        <textarea
          matInput
          cdkAutosizeMinRows="3"
          cdkAutosizeMaxRows="3"
          formControlName="summaryOfSuggestions"
        ></textarea>
      </mat-form-field>
    </div>

    <div class="d-flex justify-content-end" *ngIf="!isFormDisabled">
      <button
        class="mt-3"
        mat-flat-button
        (click)="submit()"
        color="primary"
        [disabled]="form.invalid"
      >
        {{ "forms.common.Criteria.save" | translate }}
      </button>
    </div>
  </form>
</ng-container>
